import { BaseAnalytics } from '@r1-frontend/analytics/dataLayerPush';

class TariffAnalytics extends BaseAnalytics {
    constructor(category = 'tariff') {
        super();

        this.category = category;
    }

    choose(name?: string) {
        this.send('step_choose_tariff', name);
    }

    chooseRecommended(name = '') {
        name = name.concat(' (выбранный тариф)');
        this.send('choose_recomended_tariff_slider', name);
    }

    chooseRecommendedFilter(name: string) {
        this.send('choose_recommended_tariff_filter', name);
    }

    popupOpened(label?: string) {
        this.send('popup', label);
    }

    add(title: string) {
        this.send('add', title);
    }

    remove(title: string) {
        this.send('remove', title);
    }

    clickMenu(title?: string) {
        this.send('click kebab menu', title);
    }
}

export default TariffAnalytics;
